import type { ApprovalChain } from '../approval-chain.model';

export const LAND_TENURE_SECTIONAL_TITLE_CHAIN: ApprovalChain = {
  id: 'land-tenure-sectional-title',
  label: 'Land Tenure Sectional Title',
  applicationTypes: ['LAND_TENURE_SECTIONAL_TITLE'],
  steps: [
    { role: 'FINANCE_OFFICER', action: 'Approve Payment', from: ['SUBMITTED', 'RESUBMITTED'], to: 'FINANCE_APPROVED' },
    { role: 'EXAMINER', action: 'Recommend', from: ['FINANCE_APPROVED'], to: 'EXAMINER_RECOMMENDED' },
    { role: 'REGISTRAR', action: 'Verify', from: ['EXAMINER_RECOMMENDED'], to: 'REGISTRAR_VERIFIED' },
  ],
};
